import React from 'react';
import { KeenIcon } from '@/components';
import { ContentLoader } from '@/components/loaders';

const DetailedViewWithPagination = ({
  data,
  loading = false,
  currentPage,
  totalPages,
  handleEdit,
  handleDelete,
  handlePrev,
  handleNext,
}) => {
  if (!data || data.length === 0) {
    return null; // Hoặc hiển thị thông báo rỗng nếu cần
  }

  const currentItem = data[currentPage];

  return (
    <div className="bg-white flex flex-col items-center w-full min-h-[200px]">
      {loading ? (
        <div className="flex items-center justify-center h-full w-full">
          <ContentLoader />
        </div>
      ) : (
        <>
          <div className="mb-4 w-full border rounded shadow mt-6 p-4">
            <div className="font-bold mb-2 flex justify-between">{currentItem.name}
              <span>
                {/* button xóa */}
                <button
                  className="text-gray-500 hover:text-red-600 transition-color mr-2"
                  onClick={() => handleDelete(currentItem)}
                >
                  <KeenIcon icon="trash" />
                </button>
                {/* button chỉnh sửa */}
              </span>
            </div>
            <div className="text-gray-500 mb-1">{currentItem.date}</div>
            <div>{currentItem.data}</div>
            <button
                  className="text-gray-500 hover:text-blue-600 transition-colors flex justify-end w-full"
                  onClick={() => handleEdit(currentItem)}
                >
                  <KeenIcon icon="notepad-edit" />
                </button>
          </div>
          <div className="flex gap-2 items-center justify-end w-full">
            <button
              onClick={handlePrev}
              disabled={currentPage === 0}
              className="px-3 py-1 rounded bg-gray-200 disabled:opacity-50"
            >
              Prev
            </button>
            <span>
              {currentPage + 1} / {totalPages}
            </span>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages - 1}
              className="px-3 py-1 rounded bg-gray-200 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export { DetailedViewWithPagination }; 